import { render, staticRenderFns } from "./table.vue?vue&type=template&id=684e4706&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=684e4706&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e4706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684e4706')) {
      api.createRecord('684e4706', component.options)
    } else {
      api.reload('684e4706', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=684e4706&scoped=true", function () {
      api.rerender('684e4706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/security/channelSecurity/components/table.vue"
export default component.exports